// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

/**
 * Create a new template
 * @param {*} params
 * @returns
 */
function createTaskTemplate(params: any): any {
    const baseUrl = `${config.server.api}/v1/task-templates`;
    return api.create(`${baseUrl}`, params);
}

//NOTE: BACKEND NOT IMPLEMENTED FOR THE REMAINING ENDPOINTS

/**
 * Get a new template
 * @param {*} params
 * @returns
 */
function getTaskTemplate(params: any): any {
    const id = params.id;
    const baseUrl = `${config.server.api}/v1/task-templates`;
    return api.get(`${baseUrl}`, id);
}

/**
 * Get a new template
 * @param {*} params
 * @returns
 */
function getUserTaskTemplates(params: any): any {
    const baseUrl = `${config.server.api}/v1/users/${params.user}/task-templates`;
    return api.get(`${baseUrl}`);
}

/**
 * Get a new template
 * @param {*} params
 * @returns
 */
function updateTaskTemplate(params: any): any {
    const id = params.id;
    const body = params;
    const baseUrl = `${config.server.api}/v1/task-templates`;
    return api.updatePatch(`${baseUrl}`, id, params);
}

/**
 * Get a new template
 * @param {*} params
 * @returns
 */
function deleteTaskTemplate(params: any): any {
    const id = params.id;
    const isArchived = true;
    const baseUrl = `${config.server.api}/v1/task-templates`;
    return api.updatePatch(`${baseUrl}`, id);
}

export { createTaskTemplate, getTaskTemplate, updateTaskTemplate, getUserTaskTemplates, deleteTaskTemplate };
